import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';

@Component({
  selector: '.btn',
  templateUrl: './btn.component.html',
  styleUrls: ['./btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.loading]': `loading()`,
    '[class.disabled]': `disabled()`,
    '[attr.disabled]': `disabled() || loading() || null`,
  },
  imports: []
})
export class BtnComponent implements OnInit {

  public disabled = input<boolean>(false, {alias: 'disabled'});
  public loading = input<boolean>(false, {alias: 'loading'});

  constructor() {
  }

  ngOnInit(): void {

  }

}
